import { addRequiredRule, addRequiredRuleWithMessage, removeRequiredRule, clearValidation } from "../../common/forms";
import { initTinyMceCharacterCount } from "../../common/tinymce";
import { openDialog, dialogModel } from "components/common/dialog";

const props = {
    adminEditSingleProductCoreMarker:'.marker-product-management-edit-single-product-core',
    tileContentSelector: '#TileHtmlContent',
    deleteProductItemButton: "#delete-product-item",
};

export function initAdminEditSingleProductCore() {

    if ($(props.adminEditSingleProductCoreMarker).length) {

        tinymce.init({
            selector: props.tileContentSelector,
            plugins:
                'advlist anchor autolink charmap code codesample fullscreen image link lists paste searchreplace table help',
            toolbar:
                'bold italic underline forecolor | ' +
                'bullist numlist | fullscreen | ' +
                'table link codesample charmap | ' +
                'alignleft aligncenter alignright alignjustify ' +
                'help',
            menu: {
                file: {
                    title: 'File',
                    items: ''
                },
                edit: {
                    title: 'Edit',
                    items: 'undo redo | cut copy paste pastetext | selectall | searchreplace'
                },
                view: {
                    title: 'View',
                    items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments'
                },
                insert: {
                    title: 'Insert',
                    items: 'image link media addcomment pageembed template codesample inserttable | charmap hr | pagebreak nonbreaking anchor toc | insertdatetime'
                },
                format: {
                    title: 'Format',
                    items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats align | forecolor | removeformat'
                },
                tools: {
                    title: 'Tools',
                    items: ''
                },
                table: {
                    title: 'Table',
                    items: 'inserttable | cell row column | advtablesort | tableprops deletetable'
                },
                help: {
                    title: 'Help',
                    items: 'help'
                }
            },
            //For more styles use content_css (see the docs)
            content_style: "body { font-size: 14px; }",
            height: 480,
            force_p_newlines: false,
            forced_root_block: '',
            init_instance_callback: function (editor) {

                initTinyMceCharacterCount(editor, 500, '#TileHtmlContentCharCount');
            }
        });

        handleDeleteProductItem();
    }

}


//! PRIVATE FUNCTIONS
function handleDeleteProductItem() {
    $(props.deleteProductItemButton).click(function (e) {
        e.preventDefault();
        const actionDeleteUrl = $(this).data("action-delete");

        openDialog({
            ...dialogModel,
            title: "Delete Product",
            content: "Are you sure you want to delete this product?",
            confirmButtonText: "Delete",
            onConfirm: function () {
                window.location.href = actionDeleteUrl;
            },
            theme: "delete",
        });
    });
}
